if (typeof ProductVariants !== "function") {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.locationProduct = {};
      this.variantData = [];
      this.storeLocationName = "";
      this.productVariantSelector = this.querySelector(
        "product-variant-selector"
      );
      (async () => {
        await this.getLocation();
        await this.getStoreName();
        this.init();
      })();
      // this.init();
    }

    async init() {
      await this.getVariantData();
      this.price = this.querySelector(`#product-price-${this.dataset.id}`);
      if (this.price) {
        this.priceOriginal = this.price.querySelector(
          "[data-js-product-price-original]"
        );
        this.priceCompare = this.price.querySelector(
          "[data-js-product-price-compare]"
        );
        this.priceUnit = this.price.querySelector(
          "[data-js-product-price-unit]"
        );
      }

      this.productForm = document.querySelector(
        `#product-form-${this.dataset.id}`
      );
      if (this.productForm) {
        this.productQty = this.productForm.querySelector(
          "[data-js-product-quantity]"
        );
        this.addToCart = this.productForm.querySelector(
          "[data-js-product-add-to-cart]"
        );
        this.addToCartText = this.productForm.querySelector(
          "[data-js-product-add-to-cart-text]"
        );
      }
      this.addEventListener("change", this.onVariantChange);
      document
        .querySelectorAll("store-selector[data-main-selector]")
        .forEach((element) => {
          element.addEventListener("storechanged", (e) => {
            this.querySelectorAll(
              ".product-variant__item input.disabled"
            ).forEach((item) => item.classList.remove("disabled"));
            this.dispatchEvent(new Event("change"));
          });
        });
      window.addEventListener("load", () => {
        document
          .querySelectorAll("[data-js-select-store] [data-js-change-store]")
          .forEach((element) => {
            element.addEventListener("click", (e) => {
              this.querySelectorAll(
                ".product-variant__item input.disabled"
              ).forEach((item) => item.classList.remove("disabled"));
              this.dispatchEvent(new Event("change"));
            });
          });
      });
      window.addEventListener("load", () => {
        document
          .querySelectorAll("[data-js-reset-store]")
          .forEach((resetButton) => {
            resetButton.addEventListener("click", (e) => {
              this.querySelectorAll(
                ".product-variant__item input.disabled"
              ).forEach((item) => item.classList.remove("disabled"));
              this.dispatchEvent(new Event("change"));
            });
          });
      });

      let initVariantChange = false;
      if (this.hasAttribute("data-variant-required")) {
        this.variantRequired = true;
        this.noVariantSelectedYet = true;
        if (document.location.search.includes("variant")) {
          const initVariant = parseInt(
            new URLSearchParams(document.location.search).get("variant")
          );
          const variantData = this.variantData;

          this.currentVariant = variantData.find((variant) => {
            if (variant.id == initVariant) {
              variant.options.map((option, index) => {
                const variantContainer = this.querySelectorAll(
                  `[data-js-product-variant]`
                )[index].querySelector(`[data-js-product-variant-container]`);
                if (
                  variantContainer.dataset.jsProductVariantContainer == "radio"
                ) {
                  variantContainer.querySelector(
                    `input[value="${option}"]`
                  ).checked = true;
                } else if (
                  variantContainer.dataset.jsProductVariantContainer == "select"
                ) {
                  variantContainer.value = option;
                }
              });
              return variant;
            }
          });

          if (this.currentVariant) {
            this.variantRequired = false;
            this.noVariantSelectedYet = false;
            initVariantChange = true;
          }
        }
      } else {
        this.variantRequired = false;
        this.noVariantSelectedYet = false;
      }
      const vidEl = this.querySelector("[data-variant-id]");
      if (vidEl) {
        const variantId = Number(vidEl.getAttribute("data-variant-id"));
        this.getCart(variantId);
        this.getQuantityLocation(variantId);
      }
      this.updateOptions();
      this.updateMasterId();
      this.updateUnavailableVariants();
      this.checkBtnAddToCart();

      this.productStock = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity]`
      );
      this.productStockProgress = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity-progress]`
      );
      if (
        this.productStock &&
        document.querySelector(
          `#product-${this.dataset.id} [data-js-variant-quantity-data]`
        )
      ) {
        this.productStockData = JSON.parse(
          document.querySelector(
            `#product-${this.dataset.id} [data-js-variant-quantity-data]`
          ).dataset.inventory
        );
      }
      this.updateStock();

      if (initVariantChange) {
        this.onVariantChange();
      }
      this.updatePickupAvailabilityEachStore();

      this.dispatchEvent(new Event("INITLOCATION"));
    }
    async getLocation() {
      try {
        const token = window.KROWN.settings.storefront_api_key;
        const domain = window.KROWN.settings.store_domain;
        const productId = document
          .querySelector("[data-id]")
          .getAttribute("data-id");
        const query = `#graphql
					query Product($id: ID!) {
						product(id: $id) {
							availableForSale
							id
							title
							totalInventory
							variants(first: 250) {
								nodes {									
                  components(first: 1) {
										nodes {
											productVariant{
												id
												storeAvailability (first: 250) {
													nodes {
														available
														location {
															id
															name
														}
														quantityAvailable
													}
												}
											}
											quantity
										}
									}
									id
									title
									quantityAvailable
									storeAvailability (first: 250) {
										nodes {
											available
											location {
												id
												name
											}
											quantityAvailable						
										}
									}
								}
							}
						}
					}
				`;

        const body = {
          query: query,
          variables: {
            id: `gid://shopify/Product/${productId}`,
          },
        };
        const response = await fetch(
          `https://${domain}/api/2025-07/graphql.json`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": token,
            },
            body: JSON.stringify(body),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        if (!data.data.product) {
          console.error("Product not found");
          return;
        }
        this.locationProduct = data;

        return this.locationProduct;
      } catch (error) {
        console.error("Error fetching data:", error);
        return null;
      }
    }
    async getStoreName() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          let storeName = document
            .querySelector("#site-store-selector-handle [data-store-label]")
            .getAttribute("data-store-label");
          this.storeLocationName = storeName;
          resolve(storeName);
        }, 0);
      });
    }
    async getVariantData() {
      const arrayVariantsLocation = this.locationProduct.data;
      const inventory_policies = JSON.parse(
        this.querySelector("script[data-js-variant-inventory-policy]")
          .textContent
      );

      const variantIds = new Map();
      const storeName = await this.getStoreName();

      arrayVariantsLocation.product.variants.nodes.forEach((item) => {
        const parsedId = item.id.split("gid://shopify/ProductVariant/")[1];

        const inventory_policy = inventory_policies.find(
          (policy) => Number(policy.id) === Number(parsedId)
        )?.inventory;
        const hasComponents = item.components?.nodes?.length > 0;

        const variantsToMap = hasComponents
          ? item.components.nodes[0].productVariant.storeAvailability.nodes
          : item.storeAvailability.nodes;
        variantsToMap.forEach((storeAvailability) => {
          const loc = storeAvailability;
          if (storeAvailability.location.name === storeName) {
            const quantityAvailable = hasComponents ? Math.floor(storeAvailability.quantityAvailable / item.components.nodes[0].quantity) : storeAvailability.quantityAvailable;
            if (inventory_policy === "continue") {
              variantIds.set(Number(parsedId), true);
            } else if (quantityAvailable <= 0) {
              variantIds.set(Number(parsedId), false);
            } else {
              variantIds.set(Number(parsedId), true);
            }
          }
        });
      });

      let arrayVariants = JSON.parse(
        this.querySelector("[data-js-variants-data]").textContent
      );
      arrayVariants = arrayVariants.map((v) => {
        if (variantIds.has(v.id)) {
          v.available = variantIds.get(v.id);
        }
        return v;
      });
      this.variantData = arrayVariants;
    }
    checkBtnAddToCart() {
      if (this.productForm) {
        if (!this.currentVariant || !this.currentVariant.available) {
          if (this.productQty) this.productQty.style.display = "none";
          this.addToCart.classList.add("disabled");
          this.productForm.classList.add("disabled-cart");
          this.addToCartText.textContent =
            KROWN.settings.locales.products_sold_out_variant;
        } else {
          if (this.productQty) this.productQty.style.display = "";
          this.addToCart.classList.remove("disabled");
          this.productForm.classList.remove("disabled-cart");
          this.addToCartText.textContent = this.hasAttribute(
            "data-show-bundle-wording"
          )
            ? KROWN.settings.locales.products_add_to_bundle_button
            : KROWN.settings.locales.products_add_to_cart_button;
        }
        if (!this.currentVariant) {
          this.productForm.classList.add("unavailable-variant");
          this.addToCartText.textContent =
            this.variantRequired && this.noVariantSelectedYet
              ? KROWN.settings.locales.products_variant_required
              : KROWN.settings.locales.products_unavailable_variant;
        } else {
          this.productForm.classList.remove("unavailable-variant");
        }
      }
    }
    async onVariantChange() {
      await this.getStoreName();
      await this.getVariantData();
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantInput();
      this.getQuantityLocation(this.currentVariant.id);
      if (this.price) {
        this.updatePrice();
      }
      this.updatePickupAvailabilityEachStore();
      this.updateStock();
      this.updateUnavailableVariants();
      this.updatePickupAvailability();
      if (!this.hasAttribute("data-no-history")) {
        this.updateURL();
      }
      this.updatePhotoMetafields();
      this.updateDetails();
      this.checkBtnAddToCart();
      this.dispatchEvent(new Event("VARIANT_CHANGE"));
    }
    updatePhotoMetafields() {
      let arrayVariantsMetafields = JSON.parse(
        document.querySelector("[data-js-variant-metafield]").innerText
      );
      let image = document.querySelector("[data-js-nutrition_facts]");
      if (!image) {
        return;
      }
      let imgDefault = image.innerText;
      const variantMetafieldImage = arrayVariantsMetafields.find(
        (item) => item.id === this.currentVariant.id
      );
      let imgInfo = document.querySelector("toggle-tab img");
      if (imgInfo != null) {
        if (variantMetafieldImage.image != "undefined") {
          imgInfo.srcset = variantMetafieldImage.image;
          imgInfo.src = variantMetafieldImage.image;
        } else {
          imgInfo.srcset = imgDefault;
          imgInfo.src = imgDefault;
        }
        if (
          imgInfo.closest("figure").querySelector(".img-magnifier-glass") !=
          null
        ) {
          imgInfo
            .closest("figure")
            .querySelector(".img-magnifier-glass")
            .remove();
        }
        magnify("img-magnifier", 3);
      }
    }
    updateOptions() {
      this.options = [];

      this.querySelectorAll("[data-js-product-variant-container]").forEach(
        (elm) => {
          if (elm.dataset.jsProductVariantContainer == "radio") {
            elm.querySelectorAll(".product-variant__input").forEach((el) => {
              if (el.checked) {
                this.options.push(el.value);
              }
            });
          } else {
            if (!(this.variantRequired && elm.selectedIndex == 0)) {
              this.options.push(elm.value);
            }
          }
        }
      );

      if (
        this.variantRequired &&
        this.noVariantSelectedYet &&
        this.options.length >= parseInt(this.dataset.variants)
      ) {
        this.noVariantSelectedYet = false;
      }
    }
    async updateMasterId() {

      this.currentVariant = this.variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updatePrice() {
      if (!this.currentVariant) {
        if (!(this.variantRequired && this.noVariantSelectedYet)) {
          this.priceOriginal.innerHTML = "";
          this.priceCompare.innerHTML = "";
          this.priceUnit.innerHTML = "";
        }
      } else {
        this.priceOriginal.innerHTML = this._formatMoney(
          this.currentVariant.price,
          KROWN.settings.shop_money_format
        );
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          this.priceCompare.innerHTML = this._formatMoney(
            this.currentVariant.compare_at_price,
            KROWN.settings.shop_money_format
          );
        } else {
          this.priceCompare.innerHTML = "";
        }

        if (this.currentVariant.unit_price_measurement) {
          this.priceUnit.innerHTML = `
						${this._formatMoney(
              this.currentVariant.unit_price,
              KROWN.settings.shop_money_format
            )} /
						${
              this.currentVariant.unit_price_measurement.reference_value != 1
                ? this.currentVariant.unit_price_measurement.reference_value +
                  " "
                : ""
            }
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
        } else {
          this.priceUnit.innerHTML = "";
        }
      }
    }

    updateStock() {
      if (!this.currentVariant) {
        if (this.productStock) {
          this.productStock.innerHTML = "";
        }
      } else {
        if (this.productStock && this.productStockData) {
          let currentVariant = false;
          for (const variant of this.productStockData) {
            if (variant.id == this.currentVariant.id) {
              currentVariant = variant;
              break;
            }
          }
          this.productStock.innerHTML = "";

          if (currentVariant) {
            if (currentVariant.quantity <= 0) {
              if (currentVariant.inventory == "continue") {
                this.productStock.innerHTML =
                  KROWN.settings.locales.products_preorder;
              } else if (currentVariant.inventory == "deny") {
                this.productStock.innerHTML =
                  KROWN.settings.locales.products_no_products;
              }
            } else if (currentVariant.quantity == "1") {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_one_product;
            } else if (
              currentVariant.quantity <=
              parseInt(this.productStock.dataset.lowStock)
            ) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_few_products.replace(
                  "{{ count }}",
                  currentVariant.quantity
                );
            } else if (currentVariant.unavailable) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_no_products;
            } else if (
              currentVariant.quantity >
                parseInt(this.productStock.dataset.lowStock) &&
              this.productStock.dataset.type == "always"
            ) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_few_products.replace(
                  "{{ count }}",
                  currentVariant.quantity
                );
            } else if (!currentVariant.quantity) {
              this.productStock.innerHTML =
                KROWN.settings.locales.products_enough_products;
            }

            if (this.productStockProgress) {
              let progressQty = 0;
              if (
                (currentVariant.quantity <= 0 &&
                  currentVariant.inventory == "continue") ||
                typeof currentVariant.quantity === "undefined"
              ) {
                progressQty = parseInt(this.productStock.dataset.highStock);
              } else if (currentVariant.quantity > 0) {
                progressQty = currentVariant.quantity;
              }
              if (
                progressQty >= parseInt(this.productStock.dataset.highStock)
              ) {
                this.productStockProgress.style.width = `100%`;
              } else {
                this.productStockProgress.style.width = `${
                  (100 * progressQty) /
                  parseInt(this.productStock.dataset.highStock)
                }%`;
              }
            }
          }
        }
      }
    }

    updateDetails() {
      document
        .querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`)
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.sku) {
            elm.innerHTML =
              KROWN.settings.locales.product_sku + this.currentVariant.sku;
          } else {
            elm.innerHTML = "";
          }
        });

      document
        .querySelectorAll(
          `#product-${this.dataset.id} [data-js-product-barcode]`
        )
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.barcode) {
            elm.innerHTML =
              KROWN.settings.locales.product_barcode +
              this.currentVariant.barcode;
          } else {
            elm.innerHTML = "";
          }
        });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    updatePickupAvailabilityEachStore() {
      const allStores = document.querySelectorAll(
        ".store-selector-item[data-title]"
      );

      const variantsLocation =
        this.locationProduct.data.product.variants.nodes.find(
          (item) =>
            item.id.split("gid://shopify/ProductVariant/")[1] ==
            this.currentVariant.id
        );

      if (!variantsLocation) return;

      allStores.forEach((store) => {
        const itemName = store.getAttribute("data-title");
        const itemAvailable = store.querySelector(
          ".store-selector-item__available"
        );

        const location = variantsLocation.storeAvailability.nodes.find(
          (storeAvailability) => storeAvailability.location.name === itemName
        );
        const inventory_policies = JSON.parse(
          this.querySelector("script[data-js-variant-inventory-policy]")
            .textContent
        );
        if (location) {
          const parsedId = variantsLocation.id.split(
            "gid://shopify/ProductVariant/"
          )[1];



          const inventory_policy = inventory_policies.find(
            (policy) => Number(policy.id) === Number(parsedId)
          )?.inventory;

          itemAvailable.classList.toggle(
            "alert--success",
            (location.available && location.available != "-") ||
              inventory_policy === "continue"
          );
          itemAvailable.classList.toggle(
            "alert--error",
            !(
              (location.available && location.available != "-") ||
              inventory_policy === "continue"
            )
          );
        }
      });
    }

    updateUnavailableVariants() {
      if (this.dataset.hideVariants != "false") {
        let options1 = {},
          options2 = {},
          options3 = {},
          option1Selected = null,
          option2Selected = null;

        if (this.dataset.variants > 0) {
          option1Selected = this._getSelectedOption(0);
          this._resetDisabledOption(0);
        }
        if (this.dataset.variants > 1) {
          option2Selected = this._getSelectedOption(1);
          this._resetDisabledOption(1);
        }

        this.variantData.forEach((el) => {
          if (this.dataset.variants > 0) {
            if (!options1[el.option1]) {
              options1[el.option1] = [];
            }
            options1[el.option1].push(String(el.available));
          }
          if (this.dataset.variants > 1) {
            if (!options2[el.option2]) {
              options2[el.option2] = [];
            }
            options2[el.option2].push(String(el.available));
          }
          if (this.dataset.variants == 2) {
            if (el.option1 == option1Selected && !el.available) {
              this._setDisabledOption(1, el.option2);
            }
          }
          if (this.dataset.variants > 2) {
            if (!options3[el.option3]) {
              options3[el.option3] = [];
            }
            options3[el.option3].push(String(el.available));
            if (
              el.option2 == option2Selected &&
              el.option1 == option1Selected &&
              !el.available
            ) {
              this._setDisabledOption(2, el.option3);
            }
          }
        });

        if (this.dataset.variants > 0) {
          Object.keys(options1).forEach((key) => {
            if (!options1[key].includes("true")) {
              this._setDisabledOption(0, key);
            }
          });
        }
        if (this.dataset.variants > 1) {
          Object.keys(options2).forEach((key) => {
            if (!options2[key].includes("true")) {
              this._setDisabledOption(1, key);
            }
          });
        }
        if (this.dataset.variants > 2) {
          Object.keys(options3).forEach((key) => {
            if (!options3[key].includes("true")) {
              this._setDisabledOption(2, key);
            }
          });
          Object.keys(options2).forEach((key) => {
            if (!options2[key].includes("true")) {
              if (option2Selected == key) {
                if (this.dataset.hideVariants == "disable") {
                  this.querySelectorAll("[data-js-product-variant]")[2]
                    .querySelector(".product-variant-value")
                    .setAttribute("disabled", "disabled");
                } else {
                  this.querySelectorAll("[data-js-product-variant]")[2]
                    .querySelector(".product-variant-value")
                    .classList.add("disabled");
                }
              }
            }
          });
        }
      }
    }

    _getSelectedOption(i) {
      let selectedOption = null;
      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll("[data-js-product-variant-container]")
        .forEach((elm) => {
          if (elm.dataset.jsProductVariantContainer == "radio") {
            elm.querySelectorAll(".product-variant__input").forEach((el) => {
              if (el.checked) {
                selectedOption = el.value;
              }
            });
          } else {
            selectedOption = elm.value;
          }
        });
      return selectedOption;
    }

    _resetDisabledOption(i) {
      this.querySelectorAll("[data-js-product-variant]")
        [i].querySelectorAll(".product-variant-value")
        .forEach((elm) => {
          elm.classList.remove("disabled");
          elm.classList.remove("hide-variant");
          if (!elm.hasAttribute("default")) {
            elm.removeAttribute("disabled");
          }
          elm.parentNode.classList.remove("hide-variant");
        });
    }

    _setDisabledOption(i, option) {
      let variant = this.querySelectorAll("[data-js-product-variant]")[
        i
      ].querySelector(
        `.product-variant-value[value="${option.replace('"', "&x22;")}"]`
      );

      if (variant) {
        if (this.dataset.hideVariants == "disable") {
          variant.setAttribute("disabled", "disabled");
        } else if (this.dataset.hideVariants == "true") {
          variant.classList.add("disabled");
        } else if (this.dataset.hideVariants == "hide") {
          if (
            this.querySelectorAll("[data-js-product-variant]")[i].querySelector(
              "[data-js-product-variant-container]"
            ).dataset.jsProductVariantContainer == "radio"
          ) {
            variant.parentNode.classList.add("hide-variant");
          } else {
            variant.classList.add("hide-variant");
          }
        }
      }
    }

    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
    getCart(currentId) {
      fetch(`${KROWN.settings.routes.cart_url}.js`, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          let currentProductInCart = data.items.find(
            (item) => item.id === Number(currentId)
          );
          if (currentProductInCart) {
            return currentProductInCart.quantity;
          }
        });
    }
    getQuantityLocation(activeId) {
      let arrayVariantsLocation = this.locationProduct.data;

      let variantQuantityLocation = [];
      let storeLocationName = this.storeLocationName;
      const inventory_policies = JSON.parse(
        this.querySelector("script[data-js-variant-inventory-policy]")
          .textContent
      );
      arrayVariantsLocation.product.variants.nodes.forEach((item) => {
        const parsedId = item.id.split("gid://shopify/ProductVariant/")[1];

        const inventory_policy = inventory_policies.find(
          (policy) => Number(policy.id) === Number(parsedId)
        )?.inventory;

        const hasComponents = item.components?.nodes?.length > 0;

        const variantsToMap = hasComponents
          ? item.components.nodes[0].productVariant.storeAvailability.nodes
          : item.storeAvailability.nodes;
        variantsToMap.forEach((storeAvailability) => {
          const loc = storeAvailability.location;
          if (loc.name === storeLocationName) {
            const quantityAvailable = hasComponents ? Math.floor(storeAvailability.quantityAvailable / item.components.nodes[0].quantity) : storeAvailability.quantityAvailable;
            variantQuantityLocation.push({
              id: Number(item.id.split("gid://shopify/ProductVariant/")[1]),
              quantity: Number(quantityAvailable),
              inventory_policy: inventory_policy,
            });
          }
        });
      });
      let currentQuantity;
      const variantLocation = variantQuantityLocation.find(
        (item) => item.id === Number(activeId)
      );

      if (variantLocation) {
        currentQuantity = variantLocation.quantity;
      }
      document
        .querySelector("[data-js-product-form]")
        .setAttribute("data-limit-location", currentQuantity);
      if (variantLocation?.inventory_policy === "continue") {
        document
          .querySelector("[data-js-product-form]")
          .setAttribute("data-limit-location", 9999);
      }
      let quantityPlus = document.querySelector(".product-quantity__plus");
      let currentQuantityInput = document.querySelector(
        ".product-quantity__selector"
      );

      if (
        Number(currentQuantityInput.value) >= currentQuantity &&
        variantLocation?.inventory_policy !== "continue"
      ) {
        quantityPlus.classList.add("disabled");
        currentQuantityInput.value = 1;
      } else {
        quantityPlus.classList.remove("disabled");
      }
      return currentQuantity;
    }
    updateVariantInput() {
      if (!this.currentVariant) return;
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.id}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("product-variants") == "undefined") {
    customElements.define("product-variants", ProductVariants);
  }
}

/* ---
	Product Form
--- */

if (typeof ProductForm !== "function") {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      if (this.hasAttribute("data-ajax-cart")) {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.ADD_TO_CART = new Event("add-to-cart");
      }
    }

onSubmitHandler(e) {
  e.preventDefault();

  const submitButton = this.querySelector('[type="submit"]');
  submitButton.classList.add("working");

  const body = this._serializeForm(this.form);
  const shouldBlockCostiesOnline = !window.COSTIES_CUSTOMER_ONLINE_ALLOWED;

  let alert = "";

  fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
    body,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    },
    method: "POST",
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status == 422) {
        alert = document.createElement("span");
        alert.style.margin = "0 auto";
        alert.className = "alert alert--error";
        alert.innerHTML = response.description;
        return null;
      }

      return fetch(`${KROWN.settings.routes.cart_url}.js`);
    })
    .then((response) => {
      if (!response) return null;
      return response.json();
    })
    .then((cart) => {
      if (!cart) return null;

      const existingAttributes = cart.attributes || {};

      return fetch(`${KROWN.settings.routes.cart_url.replace('/cart', '/cart/update')}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          attributes: {
            ...existingAttributes,
            costies_block_online: shouldBlockCostiesOnline ? "true" : "false",
          },
        }),
      });
    })
    .then(() => fetch("?section_id=helper-cart"))
    .then((response) => response.text())
    .then((text) => {
      const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html");
      const cartFormInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
      const cartSubtotalInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

      const cartItems = document.getElementById("AjaxCartForm");
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      if (alert !== "") {
        document.getElementById("AjaxCartForm").append(alert);
      }

      document.getElementById("AjaxCartSubtotal").innerHTML =
        cartSubtotalInnerHTML;

      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent = document.querySelector(
          "#AjaxCartForm [data-cart-count]"
        ).textContent;
      });

      document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
        elm.textContent = document.querySelector(
          "#AjaxCartForm [data-cart-total]"
        ).textContent;
      });

      this.dispatchEvent(this.ADD_TO_CART);
    })
    .catch((e) => {
      console.log(e);
    })
    .finally(() => {
      submitButton.classList.remove("working");
    });
}

    _serializeForm(form) {
      let arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                "=" +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    }
  }

  if (typeof customElements.get("product-form") == "undefined") {
    customElements.define("product-form", ProductForm);
  }
}

/* ---
	Product Recommendations
--- */

if (typeof ProductRecommendations !== "function") {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const event = new Event("product-recommendations-loaded");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const innerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("product-recommendations");

            if (
              innerHTML &&
              innerHTML.querySelectorAll("[data-js-product-item]").length > 0
            ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll("form").forEach((elm) => {
                if (elm.querySelector("template")) {
                  elm.append(
                    elm.querySelector("template").content.cloneNode(true)
                  );
                }
              });
              this.dispatchEvent(event);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: `0px 0px 400px 0px`,
      }).observe(this);
    }
  }

  if (typeof customElements.get("product-recommendations") == "undefined") {
    customElements.define("product-recommendations", ProductRecommendations);
  }
}

if (typeof ProductVariantSelector !== "function") {
  class ProductVariantSelector extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector("details")) {
        this.init();
      }
    }
    init() {
      const select = this.querySelector("select");
      const details = this.querySelector("details");
      details.addEventListener("click", (event) => {
        const item = event.target.closest("li");
        if (item) {
          const value = item.getAttribute("data-variant-value");
          const label = item.getAttribute("data-variant-label");
          const title = item.getAttribute("data-variant-title");
          this.querySelector("summary [data-variant-title]").textContent =
            title;
          this.querySelector("summary [data-variant-label]").textContent =
            label;

          const items = details.querySelectorAll("ul > li");

          items.forEach((item) => {
            item.classList.remove("selected");
          });
          item.classList.add("selected");

          if (select) {
            const event = new Event("change", {
              view: window,
              bubbles: true,
              cancelable: true,
            });
            select.value = value;
            select.dispatchEvent(event);
          }
          details.open = false;
          this.dispatchEvent(
            new CustomEvent("product-variant-selector:changed", {
              bubbles: true,
              detail: { value },
            })
          );
        }
      });
      document.addEventListener("click", (event) => {
        if (!details.contains(event.target) && details.open) {
          details.open = false;
        }
      });
    }
  }

  if (typeof customElements.get("product-variant-selector") == "undefined") {
    customElements.define("product-variant-selector", ProductVariantSelector);
  }
}
